import React from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../constants';
import FadeImage from '../shared/FadeImage';

const SupportDisplay = ({ support }) => {
    // Determine Type Icon Path
    let typeIconPath = '';
    // Capitalize first letter just in case (e.g. speed -> Speed)
    const type = support.Support_Type.charAt(0).toUpperCase() + support.Support_Type.slice(1).toLowerCase();

    if (['Speed', 'Stamina', 'Power', 'Guts', 'Wit'].includes(type)) {
        typeIconPath = `/images/Icon/Stats_icons/Stat_Type_${type}.png`;
    } else if (['Pal', 'Group'].includes(type)) {
        typeIconPath = `/images/Icon/Support_Icons/Support_Type_${type}.png`;
    }

    // Support Card Icon Path (Optimized)
    // w-48 (192px) is the max size. 200px provides good quality/size balance.
    const originalPath = `/images/Icon/Support_Character_Icon/Support_Card_${support.support_id}_Icon.png`;
    const cardIconPath = `${API_BASE_URL}/api/thumb?img=${originalPath}&width=200`;

    return (
        <Link
            to={`/characters/support/${support.support_id}`}
            className="flex flex-col items-center cursor-pointer group"
        >
            {/* Container */}
            <div className="relative w-24 h-24 md:w-36 md:h-36 lg:w-48 lg:h-48 shadow-md rounded-xl overflow-hidden group-hover:scale-105 transition-transform duration-300">

                {/* 1. Large Image (Background/Card Icon) */}
                <FadeImage
                    src={cardIconPath}
                    className="w-full h-full object-cover"
                    alt={`${support.char_name} - ${support.card_name}`}
                    loading="lazy"
                />

                {/* 2. Small Type Image (Overlay) - Bottom Right */}
                {typeIconPath && (
                    <img
                        src={typeIconPath}
                        className="absolute bottom-0 right-0 w-8 h-8 md:w-10 md:h-10 lg:w-[52px] lg:h-[52px] object-contain z-10"
                        alt={type}
                    />
                )}
            </div>

            {/* Name Label */}
            <div className="mt-2 text-center group-hover:text-blue-600 transition-colors">
                <p className="font-bold text-gray-800 text-sm md:text-base leading-tight">
                    {support.char_name}
                </p>
                <p className="text-xs text-gray-500">
                    {support.card_name}
                </p>
            </div>
        </Link>
    );
};

export default SupportDisplay;
// Revisado: 2025-12-16
